import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { Typography } from '@material-ui/core';
import classNames from 'classnames';
import bookingMessages from 'modules/booking/messages';

interface IBookingPositionInQueue {
  waitListOrder: number;
  className?: string;
}

const BookingPositionInQueue: FC<IBookingPositionInQueue> = ({ waitListOrder, className = '' }) => {
  const intl = useIntl();

  return (
    <Typography
      color="textSecondary"
      component="span"
      className={classNames({ [className]: !!className })}
    >
      <span>{intl.formatMessage(bookingMessages.positionInQueue)}:&nbsp;</span>
      <span>{waitListOrder}</span>
    </Typography>
  );
};

export default BookingPositionInQueue;
